import React from 'react';
import { Helmet } from 'react-helmet-async';

function RefundPolicy() {
    return (
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-lg max-w-4xl mx-auto my-10">
            <Helmet>
                <title>Cancellation & Refund Policy | Health Portal</title>
            </Helmet>
            <h1 className="text-3xl font-bold text-brand-secondary mb-2">Cancellation & Refund Policy</h1>
            <p className="mb-6 text-gray-600">Operated by Smart City Ajmer (operating as Search is End!)</p>

            <div className="space-y-6 text-gray-700">
                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">1. Subscription Cancellations</h2>
                    <p>You may cancel your Health Card subscription at any time. Cancellation will take effect at the end of your current billing cycle, and you will not be charged for the subsequent period. Your digital ID card will remain active until the end of the paid term.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">2. Refund Eligibility</h2>
                    <p>As the Health Card provides immediate access to digital services and hosting of your emergency profile, fees are generally non-refundable. However, we may offer refunds on a case-by-case basis under the following circumstances:</p>
                    <ul className="list-disc ml-6 mt-2">
                        <li>Technical errors resulting in double charges.</li>
                        <li>Inability to access the service due to prolonged technical downtime on our end within the first 7 days of purchase.</li>
                    </ul>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">3. How to Request a Refund</h2>
                    <p>To request a refund, please contact us at <strong>searchisend@smartcityajmer.com</strong> within 7 days of your transaction. Please include your Member ID and transaction details. We will process approved refunds within 5-7 business days back to the original method of payment.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-brand-primary mb-2">4. Jurisdiction</h2>
                    <p>Any legal disputes or court cases arising from refunds or cancellations will be exclusively handled by the courts located in Ajmer, which is the company's main head office city.</p>
                </section>
            </div>
        </div>
    );
}

export default RefundPolicy;
